import { render, staticRenderFns } from "./verify-email.vue?vue&type=template&id=307d69bd&scoped=true&lang=pug&"
import script from "./verify-email.vue?vue&type=script&lang=js&"
export * from "./verify-email.vue?vue&type=script&lang=js&"
import style0 from "./verify-email.vue?vue&type=style&index=0&id=307d69bd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307d69bd",
  null
  
)

export default component.exports